<div class="create-teacher">
    <h3>Create Teacher</h3>
    <mat-dialog-content class="mat-typography">
    <form [formGroup]="myForm" >
<mat-form-field appearance="fill">
    <mat-label>Teacher Name</mat-label>
    <input formControlName="TeacherName" matInput>    
  </mat-form-field>
  <div *ngIf="this.myForm.get('TeacherName').invalid && (this.myForm.get('TeacherName').dirty || this.myForm.get('TeacherName').touched)">
    Please provide a name.
  </div>
  <mat-form-field appearance="fill">
    <mat-label >Teacher Age</mat-label>
    <input formControlName="TeacherAge" matInput>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Teacher Address</mat-label>
    <textarea  formControlName="TeacherAddress" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Mobile</mat-label>
    <textarea  formControlName="mobile" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Qualification</mat-label>
    <textarea  formControlName="Qualification" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>DOJ</mat-label>
    <textarea  formControlName="DOJ" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Experience</mat-label>
    <textarea  formControlName="Experience" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Gender</mat-label>
    <textarea  formControlName="Gender" matInput></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>DOB</mat-label>
    <textarea  formControlName="DOB" matInput></textarea>
  </mat-form-field>

  <input type="file" name="file" (input)="onFileChanged($event)" accept=".jpeg,.jpg,.png,.svg" />
  <div *ngIf="progressValue | async as val">
  <mat-progress-bar mode="determinate" [value]=val></mat-progress-bar>
  </div>
  <img [src]="this.myForm.value.Image"   width="50px" height="50px"/>

<!-- <br />

{{ downloadableURL }}

<br /> -->
 
 
 
  <!-- <button type="submit" mat-button cdkFocusInitial>Save</button> -->
    </form>
  </mat-dialog-content>
     <div mat-dialog-actions>
    <button mat-raised-button color="warn" (click)="onNoClick()">Close</button>
    <button  mat-raised-button [mat-dialog-close]  color="primary" (click)="onSubmit()" [disabled]="myForm.invalid">{{this.actionName}}</button>
  </div>

</div>